import axios from 'src/utils/axios';

export const GET_ALL_CUSTOM_ACTIONS = '@custom-actions/get-all-actions';
export const ADD_CUSTOM_ACTION = '@custom-actions/add-action';
export const UPDATE_CUSTOM_ACTION = '@custom-actions/update-action';
export const DELETE_ACTION = '@custom-actions/delete-action';

export function getAllCustomActions(botId) {
  const request = axios.get(`/api/actions/all/${botId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_ALL_CUSTOM_ACTIONS,
        payload: response.data
      })
    );
  };
}

export function addOneCustomAction(customAction) {
  const request = axios.post(`/api/actions/add`, {
    customAction
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_CUSTOM_ACTION,
        payload: response.data
      })
    );
  };
}
export function updateCustomAction(customAction) {
  const request = axios.put(`/api/actions/update`, {
    customAction
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: UPDATE_CUSTOM_ACTION,
        payload: {
          customAction
        }
      })
    );
  };
}
export function deleteCustomAction(id) {
  const request = axios.delete(`/api/actions/delete/${id}`);

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_ACTION,
        payload: { id }
      })
    );
  };
}
